import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import safeTLogo from "../Images/full-logo.png";
import certificateBadge from "../Images/Safet1st_Certified_Shield.png";
import presidentSignature from "../Images/CS_signature.png";
import OscarSignature from "../Images/OscarMilian2.png";
import secLogo from "../Images/espec-logo-copy.png";
import AOSHLogo from "../Images/AOSHServices.png";
import certBottom from "../Images/bottom_cert_main.png";
import axios from "axios";
import "../App.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

function Certificate() {
  const location = useLocation();
  const [courseName, setCourseName] = useState("");
  const [currentDate, setCurrentDate] = useState();
  const [expirationDate, setExpirationDate] = useState();
  const [affiliation, setaffiliation] = useState();
  const [employer, setEmployer] = useState(null);
  const [userFullName, setUserFullName] = useState("");

  const onClickPrintScreen = () => {
    const input = document.getElementById("certificate");
    html2canvas(input, {
      logging: true,
      letterRendering: 1,
      useCORS: true,
      scale: 2,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("img/png");
      const pdf = new jsPDF("l", "mm", "a4");

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      pdf.margin = {
        horiz: 15,
        vert: 20,
      };

      pdf.addImage(imgData, "PNG", 5, 5, pageWidth - 10, pageHeight - 10);
      pdf.save("MyCertificate.pdf");
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      const { userEmail, userCourseId, courseId } = location.state || {};
      if (!userEmail || !userCourseId || !courseId) return;

      try {
        const res = await axios.post("/findTeamMember", { userEmail });
        const teamMembers = res.data?.teamMembers || [];

        const matchingMember = teamMembers.find((member) =>
          member?.userCourseIds?.some((item) =>
            item?.userCourseId === userCourseId &&
            item?.courseId === courseId
          )
        );

        if (!matchingMember?.teamId) return;

        const teamRes = await axios.post("/returnTeamName", {teamId: matchingMember.teamId})
        setEmployer(teamRes.data || null);
      } catch (err) {
        console.error("Error in fetchData:", err);
      }
    }
    fetchData();
  }, [location.state]);

  useEffect(() => {
    const fetchUserFullName = async () => {
      const userEmail = location.state?.userEmail;

      if (!userEmail) return;

      try {
        const res = await axios.post("/getUserFullName", {
          userEmail,
        });

        setUserFullName(res.data.fullName);
      } catch (err) {
        console.error("Error retrieving user full name:", err);
      }
    };

    fetchUserFullName();
  }, [location.state?.userEmail]);

  useEffect(() => {
    let months = [
      "Jan", "Feb", "Mar",
      "Apr", "May", "Jun",
      "Jul", "Aug", "Sep",
      "Oct", "Nov", "Dec",
    ];
    if (location.state?.courseId) {
      axios
        .post("/returnCourseInfo", { courseId: location.state.courseId })
        .then((data) => {
          const courseName = data.data.name;
          setCourseName(courseName);

          let affiliation = data.data?.affiliation;
          setaffiliation(affiliation);


          // Pull Certification Date
          let d = new Date(location.state.createAt);

          let day = d.getDate();
          let monthName = months[d.getMonth()];
          let year = d.getFullYear();
          let post = day === 1 || day === 21 || day === 31 ? "st, "
            : day === 2 || day === 22 ? "nd, " : "th, ";  
          let certDate = monthName + " " + day + post + year;

          // Pull Expiration Date
          let expDate = "";
          let nextYear = new Date(year + (data.data.expireMonth/12), d.getMonth(), day);
          let nextYearDay = nextYear.getDate();
          let nextYearMonthName = months[nextYear.getMonth()];
          let nextYearYear = nextYear.getFullYear();
          let postNextYear = day === 1 || day === 21 || day === 31 ? "st, "
            : day === 2 || day === 22 ? "nd, " : "th, ";

          expDate = nextYearMonthName + " " + nextYearDay + postNextYear + nextYearYear;

          setCurrentDate(certDate);
          setExpirationDate(expDate);
        });
    }
  }, [location.state]);

  return (
    <Container>
      <OtherCertificateContainer>
        <OtherCertificate>
          <CertificateContainer id="certificate">
            <CertificateTop>
              <CertifiedLogoContainer>
                <CertifiedLogo src={certificateBadge} />
              </CertifiedLogoContainer>
              <Rectangle></Rectangle>
              <ArrowDown></ArrowDown>
              <ArrowDownSec></ArrowDownSec>
              <ArrowDownThird></ArrowDownThird>
            </CertificateTop>
            {/* @ Davis Edit the following lines to make Certificates  */}
            <Content>
              <UserNameContainer>
                {/* First Last */}
                {userFullName}
              </UserNameContainer>
              {employer && (
                <EmployeeNameContainer>
                  {/* DDOT - Detroit Department of Transportation */}
                  {employer}
                </EmployeeNameContainer>
              )}
              <CertificateIDContainer>
                {/* MICD-2026BV6Y-BM640287 */}
                {`${location.state.certificateID}`}
              </CertificateIDContainer>

              <Line1>
                eSpec Software affirms that the employee listed above has completed the
              </Line1>
              <Line2>
                examination in accordance with state regulations and
                standards for
              </Line2>
              <CourseNameContainer>
                {/* Michigan Petroleum Class C Dispenser */}
                {courseName}
              </CourseNameContainer>
              <CerificateID></CerificateID>

              <CertificateExpiration>
                <Current>Completed: {currentDate}</Current>
                <Expiration>Expires: {expirationDate}</Expiration>
                {/* <Current>Completed: June 2nd, 2026</Current>
                <Expiration>Expires: June 2nd, 2028</Expiration> */}
              </CertificateExpiration>
              <InnerContent>
                  {affiliation === "AOSH" ? (
                    <CertificateSignature>
                      <CompanyLogo>
                        <SecLogo src={AOSHLogo} />
                      </CompanyLogo>
                      <Signature>
                        <SignatureContainer>
                          <ManagerSignature src={OscarSignature} />
                        </SignatureContainer>
                        <PresidentName>Oscar Milian, Instructor</PresidentName>
                      </Signature>
                      <CompanyLogo>
                        <SecLogo src={secLogo} />
                      </CompanyLogo>
                    </CertificateSignature>
                  ) : (
                    <CertificateSignature>
                      <CompanyLogo>
                        <SecLogo src={safeTLogo} />
                      </CompanyLogo>
                      <Signature>
                        <SignatureContainer>
                          <ManagerSignature src={presidentSignature} />
                        </SignatureContainer>
                        <PresidentName>Casey Smith, President</PresidentName>
                      </Signature>
                      <CompanyLogo>
                        <SecLogo src={secLogo} />
                      </CompanyLogo>
                    </CertificateSignature>
                  )}
              </InnerContent>
            </Content>
            <Footer>
              eSpec Software LLC. Phone:(800)274-4437 Address: 12815 Premier
              Center Court Plymouth, MI 48170 Website:
              https://safet1stonline.com{" "}
            </Footer>
          </CertificateContainer>
        </OtherCertificate>
        <PrintScreenContainer>
          <PrintScreenButton onClick={onClickPrintScreen}>
            Download Certificate
          </PrintScreenButton>
        </PrintScreenContainer>
        
        { /* Used for adding in components in the backend... use cautiously*/
          /* <button onClick={runBackfill}>
          Backfill Certificate IDs
        </button> */}
      </OtherCertificateContainer>
    </Container>
  );
}

export default Certificate;

const Container = styled.div`
  padding: 90px 20px 20px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
const CertificateContainer = styled.div`
  max-width: 900px;
  max-height: 600px;
  min-width: 700px;
  width: 100%;
  aspect-ratio: 11 / 8.5;
  border: 10px solid #189ab4;
  /* padding: 20px; */
  background-image: repeating-linear-gradient(
    11deg,
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.5) 1px,
    transparent 0px,
    transparent 4px
  );
  background-size: 8px;
`;

const Content = styled.div``;

const InnerContent = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 0 30px 0;
  font-size: 11px;
`;

const UserNameContainer = styled.div`
  margin: 20px auto 10px auto;
  display: flex;
  width: 50%;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-size: 25px;
  font-weight: 700;
`;
const EmployeeNameContainer = styled.div`
  margin: 10px auto;
  display: flex;
  width: 60%;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-size: 25px;
  border-top: 1px solid black;
`;
const CertificateIDContainer = styled.div`
  margin: 10px 0 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
`;
const Line1 = styled.div`
  margin: 5px 0 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* font-size: 25px; */
  /* font-weight: 800; */
`;
const Line2 = styled.div`
  margin: 5px 0 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* font-size: 25px; */
  /* font-weight: 800; */
`;

const CerificateID = styled.div``;

const CourseNameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  margin: 20px 0 0 0;
  /* font-weight: 800; */
  font-weight: 800;
`;
const CertificateExpiration = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const CertificateSignature = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin: 10px 0 10px 0;
  width: 100%;
`;
const ManagerSignature = styled.img`
  width: 150px;
`;
const CertifiedLogo = styled.img`
  /* position: absolute;
  left: 0;
  top: 0;

  /* height: 100%;
  width: 100%; */
  margin-top: 10px;
  /* background-image: url(${certificateBadge});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain; */
  /* -webkit-filter: grayscale(1) invert(1);
  filter: grayscale(1) invert(1); */
  height: 150px;
  /* opacity: 0.2; */
  /* position: absolute; */
  /* background-image: url(certificateBadge); */
`;
const Current = styled.div`
  padding: 0 5px 0 5px;
`;
const Expiration = styled.div`
  border-left: 2px solid black;
  padding: 0 5px 0 5px;
`;

const PresidentName = styled.div`
  /* position: absolute; */
  border-top: 2px solid black;
  padding: 10px 0 10px 0;
  font-weight: 600;
`;

const SignatureContainer = styled.div`
  /* position: absolute; */
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Signature = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 50px 0 50px;
  /* position: relative;
  width: 100%; */
  /* background: url(${certBottom}); */
`;

const CompanyLogo = styled.div``;
const SecLogo = styled.img`
  width: 150px;
`;
const CertifiedLogoContainer = styled.div`
  /* margin: 40px; */
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000 !important;
`;

const CertificateTop = styled.div`
  width: 100%;
  z-index: 2;
  position: relative;
  height: 150px;
`;

const ArrowDown = styled.div`
  /* width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;

  border-top: 20px solid #f00; */
  width: 100%;
  position: relative;
  text-align: center;
  /* padding: 8px; */
  margin-bottom: 6px;
  height: 60px;
  top: -35px;
  z-index: 10;
  box-sizing: border-box;
  /* width: 200px; */

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 50%;
    background: #189ab4;
    transform: skew(0deg, 6deg);
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 50%;
    background: #189ab4;
    transform: skew(0deg, -6deg);
  }
`;

const ArrowDownSec = styled.div`
  width: 100%;
  position: relative;
  text-align: center;
  /* padding: 8px; */
  margin-bottom: 6px;
  height: 60px;
  top: -95px;
  z-index: 1;
  box-sizing: border-box;
  /* width: 200px; */

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 50%;
    background: #5fb05f;
    transform: skew(0deg, 4deg);
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 50%;
    background: #5fb05f;
    transform: skew(0deg, -4deg);
  }
`;

const ArrowDownThird = styled.div`
  width: 100%;
  position: relative;
  text-align: center;
  /* padding: 8px; */
  margin-bottom: 6px;
  height: 60px;
  top: -158px;
  z-index: 0;
  box-sizing: border-box;
  /* width: 200px; */

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 50%;
    background: rgba(1, 1, 1, 1);
    opacity: 0.2;
    transform: skew(0deg, 3deg);
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 50%;
    background: rgba(1, 1, 1, 1);
    opacity: 0.2;
    transform: skew(0deg, -3deg);
  }
`;

const Rectangle = styled.div`
  height: 50px;
  width: 100%;
  background: #189ab4;
`;

const PrintScreenContainer = styled.div`
  margin-top: 20px;
`;
const PrintScreenButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 5px;
  background-color: rgba(95, 176, 95, 0.9);
  transition: all 0.2s ease-in-out;
  color: white;
  border-radius: 4px;
  border: none;
  height: 40px;

  &:hover {
    background-color: rgba(95, 176, 95, 1);
  }

  &:disabled {
    background-color: rgba(1, 1, 1, 0.1);
    cursor: default;
  }

  span {
    height: 20px !important;
    width: 20px !important;
  }
`;

const OtherCertificate = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const OtherCertificateContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
